export const API_BASE_URL = '/pcs-api';
// APK reference: https://pcsbar.portline.eu/api
